import type { Team, TeamMember } from '@urbanx/agx.agencies.client';
import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { z } from 'zod';

export const teamFormSchema = z.object({
  name: z.string().refine((name) => name.trim().length > 0, 'Team name is required.'),
  members: z.array(z.custom<TeamMember>()),
  photoUri: z.string().optional(),
  adminManagerId: z.string().optional(),
});

export const teamFormValues = (team?: Team): z.input<typeof teamFormSchema> => ({
  name: team?.name ?? '',
  members: team?.members ?? [],
  photoUri: team?.photoUri ?? undefined,
  adminManagerId: team?.adminManagerId ?? undefined,
});

export const TeamForm = createAgxForm(
  createFormDefinition({
    id: 'staff-agency-team',
    schema: teamFormSchema,
    fieldOrder: ['name', 'members', 'photoUri', 'adminManagerId'],
    resolveFields: () => ({
      name: { active: true, visible: true, disabled: false, required: true },
    }),
  })
);
